export default function Assign2InstructorInstructions(props) {
	let upload = props.upload;
	if (upload === "upload") {
		return (
			<div className=" flex flex-col gap-2 text-md text-black font-semibold">
				<div>
					If you would like us to upload the scanned booklets to Assign2, you will have to add one
					of our team members to your course as as instructor in Canvas.
				</div>
				<div>
					Please get in touch with TSQS by e-mail (tsqsweb@ualberta.ca) or in person to coordinate
					this addition.
				</div>
			</div>
		);
	} else if (upload === "doNotUpload") {
		return (
			<div className=" flex flex-col gap-2 text-md font-semibold text-black">
				<div>
					The option you have selected will have the .pdf files generated by our scanner software
					sent to you by either e-mail or a google drive link.
				</div>
			</div>
		);
	}
}
